import { bl_fi_mst_item_classification_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class ItemClassificationContainer extends BaseContainerModel {
    bl_fi_mst_item_classification_hdr: bl_fi_mst_item_classification_hdr_RowClass = new bl_fi_mst_item_classification_hdr_RowClass();
}
